import useSWR from 'swr';

import httpApi from 'hooks/api/httpApi';

import type WarehouseLocationDto from '../models/WarehouseLocationDto';

// import { config } from "@src/constants/swr";

const getWarehouseLocations = async (): Promise<WarehouseLocationDto[]> => {
    const response = await httpApi.get<{ locations: WarehouseLocationDto[] }>(
        'api/v1/locations'
    );

    return response.getData()?.locations;
};

type UseWarehouseLocationsSWR = () => {
    warehouseLocations?: WarehouseLocationDto[];
    loading: boolean;
};

const useWarehouseLocationsSWR: UseWarehouseLocationsSWR = () => {
    const { data, isLoading } = useSWR(
        '<warehouse-locations>',
        getWarehouseLocations,
        {
            // dedupingInterval: 600000, // 10min
            errorRetryCount: 3,
            // revalidateIfStale: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
        }
    );

    return {
        warehouseLocations: data,
        loading: isLoading,
    };
};

export default useWarehouseLocationsSWR;
